"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHideStampedFoilImage = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _cards = require("../../constants/cards");
/**
 * Returns whether to hide a stamped foil asset to avoid stacking issue
 * since the foil template endpoint returns all foil assets for optimatization purposes
 * @param tag
 * @param foilColor
 * @returns boolean
 */
var shouldHideStampedFoilImage = exports.shouldHideStampedFoilImage = function shouldHideStampedFoilImage(tag, foilColor) {
  return !!tag && tag.includes(_cards.STAMPED_FOIL_TAG_PREFIX) && tag !== _cards.STAMPED_FOIL_IMAGE_TAGS[foilColor || 'gold'];
};